import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { VendorProvider } from "./Store/VendorStore";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <VendorProvider>
      <App />
    </VendorProvider>
);
